import { CustomType, CustomValue, Experience } from "PFTypes";

import { Id } from "./id";

export enum SkillImportance {
  Essential = 0,
  Supporting = 1
}

export type SkillsFramework = {
  id: Id;
  name: string;
  description?: string;
  customFields: {
    id: Id;
    customType: Pick<CustomType, "id" | "name" | "display_as" | "displayAs">;
    customValue: Pick<CustomValue, "id" | "value">;
  }[];
  skills: {
    id: Id;
    importance: SkillImportance;
    experience: Experience;
    customValue: Pick<CustomValue, "id" | "value">;
  }[];
};

export type SkillsFrameworkCreateUpdateData = {
  name: string;
  description?: string;
  customFields: {
    customTypeId: Id;
    customValueId: Id;
  }[];
  skills: {
    skillId: Id;
    importance: SkillImportance;
    experience: Experience;
  }[];
};
